import { isArrayEmpty, isNullOrEmpty, orderArrayAscending } from '../../components/helpers/ObjectHelpers';
import {
    IndexedDbNames
} from '../../services/SystemNames';
import BaseIdbRepository from './BaseIdbRepository';

const Store = IndexedDbNames.LocationStore;

const LocationIdbRepository = {

    async clearAsync() {
        await BaseIdbRepository.clearAsync(Store);
    },

    async setAsync(location) {
        await BaseIdbRepository.setAsync(Store, location.locationId, location);
    },

    async getAllAsync() {
        const result = await BaseIdbRepository.getAllAsync(Store);
        return orderArrayAscending(result, "name");
    },

    async getByIdAsync(id) {
        const result = await BaseIdbRepository.getAllAsync(Store);
        return result.find(l => l.locationId === id);
    },

    async searchAsync(searchText, types = []) {
        if (isNullOrEmpty(searchText)) return [];

        const all = await BaseIdbRepository.getAllAsync(Store);
        const result = all.filter((e) => {
            let success = false;
            const lowerCaseName = e.name.toLowerCase();

            if (Object.hasOwn(e, "locationCode")) {
                const lowerCaseCode = e.locationCode.toLowerCase();
                success = lowerCaseName.startsWith(searchText.toLowerCase()) ||
                    lowerCaseCode.startsWith(searchText.toLowerCase()) ||
                    `no${lowerCaseCode}`.startsWith(searchText.toLowerCase());
            } else {
                success = lowerCaseName.startsWith(searchText.toLowerCase());
            }

            if (!isArrayEmpty(types)) {
                success = types.includes(e.systemName);
            }

            return success;
        });

        return orderArrayAscending(result, "name");
    },
};

export default LocationIdbRepository;
